import axios from 'axios';

import endpoints from '../endpoints';
import { AuthService } from '../../state/auth.service';

const TOKEN_REFRESH_TIMEOUT = 45 * 60 * 1000;
const getHeaders = () => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `${AuthService.getToken()}`,
  };
};

export default {
  signIn(email, password) {
    return axios
      .post(
        endpoints.AUTH_SIGIN_IN,
        {
          email: email,
          password: password,
        },
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        AuthService.signIn(
          response.data.token,
          response.data.user,
          response.data.refreshToken,
          response.data.idToken
        );
      })
      .catch(err => {
        let message = 'Error signing into account from the server.';
        if (err && err.response && err.response.data) {
          message = err.response.data.message;
        }
        throw message;
      });
  },

  isPayer(email) {
    return axios
      .post(
        `${endpoints.BILLING_BASE}/purchaserCheck`,
        {
          email: email,
        },
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        return response;
      })
      .catch(err => {
        let message = 'Error in querying payer table.';
        if (err && err.response && err.response.data.message) {
          message = err.response.data.message;
        }
        throw message;
      });
  },

  refreshToken() {
    let _this = this;
    setTimeout(function() {
      _this.refreshToken.call(_this);
    }, TOKEN_REFRESH_TIMEOUT);
    let token = AuthService.getToken();
    let refreshToken = AuthService.getRefreshToken();
    let idToken = AuthService.getIdToken();
    if (!token || !refreshToken || !idToken) {
      return;
    }
    return axios
      .post(
        endpoints.REFRESH_TOKEN,
        {
          refreshToken: refreshToken,
          idToken: idToken,
        },
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        AuthService.setToken(response.data.token);
      });
  },
};



// WEBPACK FOOTER //
// ./src/api/auth/index.js